var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container"},[_c('div',{ref:"editor",attrs:{"id":"editor"}}),_c('input',{ref:"file_click",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.fileUpload}})])}
var staticRenderFns = []

export { render, staticRenderFns }